module.exports = __webpack_public_path__ + "./Matthew_color_92c43fcdac661b87f567b99b64f99c53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Matthew_color.jpg
// module id = 600
// module chunks = 0